import React from 'react'
import AppliedFilters from '../AppliedFilters/AppliedFilters'

const QUICK_LINK_GROUPS = [
  {
    label: 'Date',
    exclusive: true,
    links: [
      { key: 'today', label: 'Today', filter: { fieldName: 'dueDate', operator: 'today', value: '', filterType: 'date' } },
      { key: 'thisWeek', label: 'This Week', filter: { fieldName: 'dueDate', operator: 'thisWeek', value: '', filterType: 'date' } },
      { key: 'thisMonth', label: 'This Month', filter: { fieldName: 'dueDate', operator: 'thisMonth', value: '', filterType: 'date' } },
    ],
  },
  {
    label: 'Billing',
    exclusive: false,
    links: [
      { key: 'ach', label: 'ACH', filter: { fieldName: 'billing', operator: 'ach', value: '', filterType: 'billing' } },
      { key: 'creditCard', label: 'Credit Card', filter: { fieldName: 'billing', operator: 'creditCard', value: '', filterType: 'billing' } },
    ],
  },
  {
    label: 'Plan Status',
    exclusive: false,
    links: [
      { key: 'activePlans', label: 'Active Plans', filter: { fieldName: 'paymentPlanStatus', operator: 'active', value: '', filterType: 'paymentPlanStatus' } },
    ],
  },
]

const isFilterActive = (filter, requestFilters) => {
  return requestFilters.some(f =>
    f.fieldName === filter.fieldName &&
    f.filterType === filter.filterType &&
    f.operator === filter.operator
  )
}

const QuickLinks = ({ requestFilters, onFiltersChange, filterDefs, utilDefs }) => {
  const handleToggle = (link, group) => {
    const active = isFilterActive(link.filter, requestFilters)

    if (active) {
      const updated = requestFilters.filter(f =>
        !(f.fieldName === link.filter.fieldName &&
          f.filterType === link.filter.filterType &&
          f.operator === link.filter.operator)
      )
      onFiltersChange(updated.length > 0 ? updated : [])
      return
    }

    let updated = [...requestFilters]

    if (group.exclusive) {
      updated = updated.filter(f =>
        !(f.fieldName === link.filter.fieldName && f.filterType === link.filter.filterType)
      )
    }

    updated = updated.filter(f => f.fieldName || f.operator || f.value)
    updated.push(link.filter)
    onFiltersChange(updated)
  }

  const activeFilters = requestFilters.filter(f => f.fieldName || f.operator || f.value)

  const handleRemoveFilter = (index) => {
    const updated = activeFilters.filter((_, i) => i !== index)
    onFiltersChange(updated.length > 0 ? updated : [])
  }

  const handleClearAll = () => {
    onFiltersChange([])
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-1.5 flex-wrap">
        {QUICK_LINK_GROUPS.map((group, gi) => (
          <React.Fragment key={group.label}>
            {gi > 0 && <div className="w-px h-4 bg-divider mx-0.5" />}
            {group.links.map(link => {
              const active = isFilterActive(link.filter, requestFilters)
              return (
                <button
                  key={link.key}
                  onClick={() => handleToggle(link, group)}
                  className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors cursor-pointer ${
                    active
                      ? 'bg-primary-main/10 text-primary-main border-primary-main/30'
                      : 'text-text-secondary border-divider/60 hover:border-primary-main/40 hover:text-primary-main'
                  }`}
                >
                  {link.label}
                </button>
              )
            })}
          </React.Fragment>
        ))}
      </div>

      <AppliedFilters
        requestFilters={requestFilters}
        filterDefs={filterDefs}
        utilDefs={utilDefs}
        onRemove={handleRemoveFilter}
        onClearAll={handleClearAll}
      />
    </div>
  )
}

export default QuickLinks
